export const tokenVar = (token: string): string => {
  const formatted = token
    .replace(/\./g, '-')
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .toLowerCase()
  return `var(--chakra-colors-${formatted})`
}
